import { convertGrouperData } from 'src/services/converters/GrouperServiceConverter';
import { GetGrouperDataResponse } from 'src/contracts/getGrouperDataResponse';
import { GrouperData } from 'src/contracts/grouperData';
import { CalculateDrgRequestDto, SaveDrgRequestDto } from 'src/contracts/calculateDrgRequestDto';
import { DrgResponseDto } from 'src/contracts/drgResponseDto';
import axiosCall, { getConfig } from 'src/services/axiosHelper';
import { DischargeStatus } from 'src/contracts/discharge-status';
import _ from 'lodash'
import { DraftState } from 'src/contracts/encoderState';

export async function getGrouperData(): Promise<GrouperData> {
  const data = await axiosCall<GetGrouperDataResponse>({
    method: 'get',
    url: `/visit/${encodeURIComponent(getConfig().visitId)}/grouper_v3`,
  });

  return convertGrouperData(data);
}

export async function saveDraft(data: DraftState): Promise<void> {
  await axiosCall({
    method: 'post',
    data,
    url: `/grouper/draft/${encodeURIComponent(getConfig().visitId)}`,
  }, true);
}

export async function discardDraft(): Promise<void> {
  await axiosCall({
    method: 'get',
    url: `/grouper/draft/${encodeURIComponent(getConfig().visitId)}/discard-draft`,
  }, true);
}

export async function getDischargeStatuses(): Promise<DischargeStatus[]> {
  const data = _.defaultTo(await axiosCall<KeyValueMap>({
    method: 'get',
    url: '/grouper/resources/discharge-statuses',
  }), {});

  const dischargeStatuses: DischargeStatus[] = [];
  for (const key in _.defaultTo(data, {})) {
    dischargeStatuses.push({ code: key, description: `${key} - ${data[key]}` });
  }
  dischargeStatuses.sort((a, b) => a.code.localeCompare(b.code));
  return dischargeStatuses;
}

export async function calculateDrg(calculateDrgRequestDto: CalculateDrgRequestDto): Promise<DrgResponseDto[]> {
  const data = await axiosCall<DrgResponseDto[]>({
    method: 'post',
    data: calculateDrgRequestDto,
    url: `/visit/${encodeURIComponent(getConfig().visitId)}/grouper_v3/calculate`,
  }, []);
  return data
}

export async function saveDrg(drgDto: SaveDrgRequestDto): Promise<void> {
  await axiosCall<boolean>({
    method: 'post',
    data: drgDto,
    url:  `/visit/${encodeURIComponent(getConfig().visitId)}/grouper_v3/drg`,
  }, true);
}

interface KeyValueMap { [key: string]: string }
